import React from 'react'
import PropTypes from "prop-types"
import {INPUT_NAMES} from "./SigninPageConstants"
import {CheckForSQL} from "./SigninPageHelpers";
import {DairyLogin} from "../../utils/APIRequests";
import "./signin-page.css"

export default class SigninPage extends React.Component{
	static defaultProps = {}
	static propTypes = {
		handleSignin: PropTypes.func.isRequired
	}
	
	constructor(props){
		super(props)
		
		this.state = {
			username: '',
			password: '',
			errorMessage: ''
		}
	}
	
	handleInput(event){
		const inputName = event.target.name
		const inputValue = event.target.value
		
		if(CheckForSQL(inputValue)){
			this.setState({
				errorMessage: 'NO: \' " = ; , SPACE OR *'
			})
		}else{
			this.setState({
				errorMessage: ''
			})
		}
		
		switch(inputName){
			case INPUT_NAMES.USERNAME:
				this.setState({
					[INPUT_NAMES.USERNAME]: inputValue
				})
				break
			case INPUT_NAMES.PASSWORD:
				this.setState({
					[INPUT_NAMES.PASSWORD]: inputValue
				})
				break
			default:
				console.log("Bad input name on signin form")
		}
	}
	
	submitSigninForm(event){
		event.preventDefault()
		
		// CALL API FOR SUBMITTING FORMS
		if(CheckForSQL(this.state.username) || CheckForSQL(this.state.password)){
			this.setState({
				errorMessage: 'NO: \' " = ; , SPACE OR *'
			})
			
			return
		}else if(this.state.username.length === 0 || this.state.password.length === 0){
			this.setState({
				errorMessage: "Please fill all fields!"
			})
		}else{
			DairyLogin(this.state.username, this.state.password, (dairyInfo) => (
				this.props.handleSignin(dairyInfo)
			))
		}
	}
	
	render(){
		return(
			<form className={"signin-form"}>
				<p>Username:</p>
				<input
					type={"text"}
					name={INPUT_NAMES.USERNAME}
					onChange={this.handleInput.bind(this)}
					value={this.state[INPUT_NAMES.USERNAME]}
				/>
				<p>Password:</p>
				<input
					type={"password"}
					name={INPUT_NAMES.PASSWORD}
					onChange={this.handleInput.bind(this)}
					value={this.state[INPUT_NAMES.PASSWORD]}
				/>
				<h4 className={"error-message"}>{this.state.errorMessage}</h4>
				<button
					type={'submit'}
					onClick={this.submitSigninForm.bind(this)}
				>Sign In</button>
			</form>
		)
	}
}